"use strict";
/* Generated by ts-generator ver. 0.0.8 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRawPerSecondCalculator = void 0;
var geb_contract_base_1 = require("@reflexer-finance/geb-contract-base");
var PRawPerSecondCalculator = /** @class */ (function (_super) {
    __extends(PRawPerSecondCalculator, _super);
    function PRawPerSecondCalculator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PRawPerSecondCalculator.prototype.adat = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "adat", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    PRawPerSecondCalculator.prototype.addAuthority = function (account) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "addAuthority", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [account]);
    };
    PRawPerSecondCalculator.prototype.addReader = function (account) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "addReader", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [account]);
    };
    PRawPerSecondCalculator.prototype.ag = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "ag", "outputs": [{ "internalType": "int256", "name": "", "type": "int256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    PRawPerSecondCalculator.prototype.allReaderToggle = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "allReaderToggle", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    PRawPerSecondCalculator.prototype.authorities = function (address, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "authorities", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [address], multicall);
    };
    PRawPerSecondCalculator.prototype.breaksNoiseBarrier = function (piSum, redemptionPrice, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "piSum", "type": "uint256" }, { "internalType": "uint256", "name": "redemptionPrice", "type": "uint256" }], "name": "breaksNoiseBarrier", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [piSum, redemptionPrice], multicall);
    };
    PRawPerSecondCalculator.prototype.computeRate = function (marketPrice, redemptionPrice, accumulatedLeak) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "marketPrice", "type": "uint256" }, { "internalType": "uint256", "name": "redemptionPrice", "type": "uint256" }, { "internalType": "uint256", "name": "accumulatedLeak", "type": "uint256" }], "name": "computeRate", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [
            marketPrice,
            redemptionPrice,
            accumulatedLeak,
        ]);
    };
    PRawPerSecondCalculator.prototype.dgt = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "dgt", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    PRawPerSecondCalculator.prototype.dos = function (i, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "i", "type": "uint256" }], "name": "dos", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "int256", "name": "", "type": "int256" }, { "internalType": "int256", "name": "", "type": "int256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [i], multicall);
    };
    PRawPerSecondCalculator.prototype.drr = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "drr", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    PRawPerSecondCalculator.prototype.folb = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "folb", "outputs": [{ "internalType": "int256", "name": "", "type": "int256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    PRawPerSecondCalculator.prototype.foub = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "foub", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    PRawPerSecondCalculator.prototype.getBoundedRedemptionRate = function (piOutput, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "int256", "name": "piOutput", "type": "int256" }], "name": "getBoundedRedemptionRate", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [piOutput], multicall);
    };
    PRawPerSecondCalculator.prototype.getGainAdjustedPIOutput = function (proportionalTerm, integralTerm, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "int256", "name": "proportionalTerm", "type": "int256" }, { "internalType": "int256", "name": "integralTerm", "type": "int256" }], "name": "getGainAdjustedPIOutput", "outputs": [{ "internalType": "int256", "name": "", "type": "int256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [proportionalTerm, integralTerm], multicall);
    };
    PRawPerSecondCalculator.prototype.getGainAdjustedTerms = function (proportionalTerm, integralTerm, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "int256", "name": "proportionalTerm", "type": "int256" }, { "internalType": "int256", "name": "integralTerm", "type": "int256" }], "name": "getGainAdjustedTerms", "outputs": [{ "internalType": "int256", "name": "", "type": "int256" }, { "internalType": "int256", "name": "", "type": "int256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [proportionalTerm, integralTerm], multicall);
    };
    PRawPerSecondCalculator.prototype.getLastIntegralTerm = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "getLastIntegralTerm", "outputs": [{ "internalType": "int256", "name": "", "type": "int256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    PRawPerSecondCalculator.prototype.getLastProportionalTerm = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "getLastProportionalTerm", "outputs": [{ "internalType": "int256", "name": "", "type": "int256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    PRawPerSecondCalculator.prototype.getNextPriceDeviationCumulative = function (proportionalTerm, accumulatedLeak, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "int256", "name": "proportionalTerm", "type": "int256" }, { "internalType": "uint256", "name": "accumulatedLeak", "type": "uint256" }], "name": "getNextPriceDeviationCumulative", "outputs": [{ "internalType": "int256", "name": "", "type": "int256" }, { "internalType": "int256", "name": "", "type": "int256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [proportionalTerm, accumulatedLeak], multicall);
    };
    PRawPerSecondCalculator.prototype.getNextRedemptionRate = function (marketPrice, redemptionPrice, accumulatedLeak, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "marketPrice", "type": "uint256" }, { "internalType": "uint256", "name": "redemptionPrice", "type": "uint256" }, { "internalType": "uint256", "name": "accumulatedLeak", "type": "uint256" }], "name": "getNextRedemptionRate", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "int256", "name": "", "type": "int256" }, { "internalType": "int256", "name": "", "type": "int256" }, { "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [marketPrice, redemptionPrice, accumulatedLeak], multicall);
    };
    PRawPerSecondCalculator.prototype.hcd = function (i, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "i", "type": "uint256" }], "name": "hcd", "outputs": [{ "internalType": "int256", "name": "", "type": "int256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [i], multicall);
    };
    PRawPerSecondCalculator.prototype.ips = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "ips", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    PRawPerSecondCalculator.prototype.lut = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "lut", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    PRawPerSecondCalculator.prototype.modifyParameters__Bytes32Int256 = function (parameter, val) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "parameter", "type": "bytes32" }, { "internalType": "int256", "name": "val", "type": "int256" }], "name": "modifyParameters", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [parameter, val]);
    };
    PRawPerSecondCalculator.prototype.modifyParameters__Bytes32Address = function (parameter, addr) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "parameter", "type": "bytes32" }, { "internalType": "address", "name": "addr", "type": "address" }], "name": "modifyParameters", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [parameter, addr]);
    };
    PRawPerSecondCalculator.prototype.modifyParameters__Bytes32Uint256 = function (parameter, val) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "parameter", "type": "bytes32" }, { "internalType": "uint256", "name": "val", "type": "uint256" }], "name": "modifyParameters", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [parameter, val]);
    };
    PRawPerSecondCalculator.prototype.nb = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "nb", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    PRawPerSecondCalculator.prototype.oll = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "oll", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    PRawPerSecondCalculator.prototype.pdc = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "pdc", "outputs": [{ "internalType": "int256", "name": "", "type": "int256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    PRawPerSecondCalculator.prototype.pscl = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "pscl", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    PRawPerSecondCalculator.prototype.readers = function (address, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "readers", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [address], multicall);
    };
    PRawPerSecondCalculator.prototype.removeAuthority = function (account) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "removeAuthority", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [account]);
    };
    PRawPerSecondCalculator.prototype.removeReader = function (account) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "removeReader", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [account]);
    };
    PRawPerSecondCalculator.prototype.rt = function (marketPrice, redemptionPrice, accumulatedLeak, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "marketPrice", "type": "uint256" }, { "internalType": "uint256", "name": "redemptionPrice", "type": "uint256" }, { "internalType": "uint256", "name": "accumulatedLeak", "type": "uint256" }], "name": "rt", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [marketPrice, redemptionPrice, accumulatedLeak], multicall);
    };
    PRawPerSecondCalculator.prototype.seedProposer = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "seedProposer", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    PRawPerSecondCalculator.prototype.sg = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "sg", "outputs": [{ "internalType": "int256", "name": "", "type": "int256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    PRawPerSecondCalculator.prototype.tlv = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "tlv", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    return PRawPerSecondCalculator;
}(geb_contract_base_1.BaseContractAPI));
exports.PRawPerSecondCalculator = PRawPerSecondCalculator;
